module.exports = __webpack_public_path__ + "media/images/common/ico-rank-2-b2780cb1ca4b7050e79b3284593031d0.svg";